import { Injectable } from '@angular/core';

import { BetBuilderConfig, EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { take } from 'rxjs';

import { SGPLaunchDarklyModeKey } from '../bet-builder.constants';

@Injectable({ providedIn: 'root' })
export class BetBuilderConfigService {
    constructor(
        private betbuilderConfig: BetBuilderConfig,
        private epcotConfig: EpcotConfig,
        private ldService: LaunchDarklyService,
    ) {}

    isBetBuilderEnabled(sportId: number): boolean {
        return (
            this.betbuilderConfig.isBetBuilderEnabled &&
            (this.betbuilderConfig.isBetBuilderEnabledForSport?.includes(sportId) || this.useBetBuilderInEntainUI(sportId))
        );
    }

    editIconButtonOverride(): boolean {
        return this.betbuilderConfig.editIconButtonOverride;
    }

    isEntainUiOverlayEnabled(): boolean {
        return this.betbuilderConfig.showEntainUiInOverlay;
    }

    useBetBuilderInEntainUI(sportId: number): boolean {
        return (this.betbuilderConfig.useBetBuilderInEntainUI?.includes(sportId) ?? false) && this.betbuilderConfig.isBetBuilderEnabled;
    }

    showEntainUiInOverlay(sportId?: number): boolean {
        if (!sportId || !this.useBetBuilderInEntainUI(sportId)) {
            return false;
        }

        let isSGPModeIsOverlay;

        this.ldService
            .getFeatureFlagValue$(SGPLaunchDarklyModeKey)
            .pipe(take(1))
            .subscribe((value) => {
                isSGPModeIsOverlay = value;
            });

        return isSGPModeIsOverlay ?? this.betbuilderConfig.showEntainUiInOverlay;
    }

    // the difference to `showEntainUiInOverlay` is that it enables additional behaviour:
    // replacing quick bet drawer with betbar, betbuilder notification message,
    // betbuilder selection error in betslip, onboarding tooltip & dialog, etc
    showEmbeddedUi(): boolean {
        return this.epcotConfig.isEnabled;
    }
}
